import { documentTypesForSubstep, ONBOARDING_SUBSTEP_IDS } from "shared-ui";

// Derived from shared-ui so the workflow tracker and this journey can't drift apart.
export const FINANCIAL_DOCUMENTS_STEP_ID = ONBOARDING_SUBSTEP_IDS.FINANCIAL_DOCUMENTS;
export const FINANCIAL_DOCUMENTS_TYPES: string[] = documentTypesForSubstep(FINANCIAL_DOCUMENTS_STEP_ID);
